// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"MobileBreadcrumb_breadcrumbContainer__O0NL_","titleContainer":"MobileBreadcrumb_titleContainer__OG2ZI","title":"MobileBreadcrumb_title__riDAx"};